<template>
  <div
    :class="[
      mode === 'editContent' || mode === 'extendedForm'
        ? 'w-full'
        : field.class,
      show ? 'showField' : 'hidden'
    ]"
    class="relative"
  >
    <input
      :id="'field' + field.id"
      v-model="voucher"
      :class="{
        'bg-green-200': response === true,
        'bg-red-200':   response === false
      }"
      :data-cy="'voucherStaticField' + field.id"
      :data-gtm-field-label="field.label"
      :data-gtm-field-id="field.id"
      :required="show && !!field.required"
      class="mainform-color mainform-input"
      :placeholder="field.label"
      type="text"
      @input="validateVoucher"
      @focus="editFields"
    />
    <label-state-icon :label-state="labelState" :required="false" />
  </div>
</template>

<script>
  import { formcreatorMixin } from '../../../plugins/mixin'
  import LabelStateIcon           from './LabelStateIcon.vue'
  import leadFormPreviewApi       from '../../connections/leadFormPreview.js'

  export default {
    name: 'VoucherStaticField',
    components: { LabelStateIcon },
    mixins: [formcreatorMixin],
    props: {
      field:      Object,
      formdata:   Object,
      mode:       String,
      validation: Object,
      isVisible:  { type: Boolean, default: false }
    },
    emits: ['field-on-focus'],
    data() {
      return {
        show:     false,
        response: null,
        voucher:  ''
      }
    },
    methods: {
      async validateVoucher() {
        if (this.mode === 'extendedForm' && this.voucher.length > 0) {
          try {
            const res = await leadFormPreviewApi.post(
              `/leads/${this.formdata.uuid}/voucher`,
              { voucher: this.voucher }
            )
            // Backend gibt { response: true/false }
            this.response = res.data.content.response === true
          } catch {
            this.response = false
          }
        } else {
          this.response = null
        }
      }
    },
    watch: {
      formdata: {
        immediate: true,
        deep:      true,
        handler() {
          this.getIfShow()
          this.validateField()
        }
      }
    }
  }
</script>
